import React from "react";
import {Collapse, Nav, Navbar, NavbarToggler, NavItem, NavLink} from "reactstrap";
import Link from "next/link";

export default function NavigationBar({active,}) {
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <div className="container navbar-container">
            <Navbar expand="md" fixed>
                <NavbarToggler onClick={() => {
                    setIsOpen(!isOpen)
                }}/>
                <Collapse isOpen={isOpen} navbar>
                    <Nav className="mx-auto" navbar>
                        <NavItem>
                            <Link href="/">
                                <NavLink active={active === "/"}>
                                    Home
                                </NavLink>

                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link href={"https://blog." + process.env.NEXT_PUBLIC_WEBSITE_HOST}>
                                <NavLink>
                                    Blog
                                </NavLink>
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link href="/faq">
                                <NavLink active={active === "/faq"}>
                                    FAQ
                                </NavLink>
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link href="/contact-us">
                                <NavLink active={active === "/contact-us"}>
                                    Contact Us
                                </NavLink>
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link href="/terms-of-use">
                                <NavLink active={active === "/terms-of-use"}>
                                    Terms of Use
                                </NavLink>
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link href="/privacy-policy">
                                <NavLink active={active === "/privacy-policy"}>
                                    Privacy Policy
                                </NavLink>
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link href="/refund-policy">
                                <NavLink active={active === "/refund-policy"}>
                                    Refund Policy
                                </NavLink>
                            </Link>
                        </NavItem>
                    </Nav>
                </Collapse>
            </Navbar>
        </div>
    )
}
